import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=056327b4&"
import script from "./TopNavigation.vue?vue&type=script&lang=ts&"
export * from "./TopNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=056327b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports